import {unexpectedCase} from 'nutshell-core/reducer-utils';

import {INITIAL_CORE_ENTITY_PAGE_STATE} from './consts';
import type {CoreEntityPageState, CoreEntityPageAction, TabOption} from './types';

const SET_CREATOR_FORM = 'SET_CREATOR_FORM';
export const setCreatorForm = (
    noteHtmlValue: string,
    notePlaintextValue: string
): CoreEntityPageAction => ({
    type: SET_CREATOR_FORM,
    payload: {
        noteHtmlValue,
        notePlaintextValue,
    },
});

const SET_CREATOR_FORM_ACTIVE = 'SET_CREATOR_FORM_ACTIVE';
export const setCreatorFormActive = (isActive: boolean): CoreEntityPageAction => ({
    type: SET_CREATOR_FORM_ACTIVE,
    payload: {
        isActive,
    },
});

const SET_ACTIVITY_TYPE_ID = 'SET_ACTIVITY_TYPE_ID';
export const setActivityTypeId = (activityTypeId?: string | null): CoreEntityPageAction => ({
    type: SET_ACTIVITY_TYPE_ID,
    payload: {
        activityTypeId,
    },
});

const SET_DURATION_MINUTES = 'SET_DURATION_MINUTES';
export const setDurationMinutes = (durationMinutes: number): CoreEntityPageAction => ({
    type: SET_DURATION_MINUTES,
    payload: {
        durationMinutes,
    },
});

const SET_PIN_NOTE = 'SET_PIN_NOTE';
export const setPinNote = (pinNote: boolean): CoreEntityPageAction => ({
    type: SET_PIN_NOTE,
    payload: {
        pinNote,
    },
});

const SET_IS_TRANSCRIBING = 'SET_IS_TRANSCRIBING';
export const setIsTranscribing = (isTranscribing: boolean): CoreEntityPageAction => ({
    type: SET_IS_TRANSCRIBING,
    payload: {
        isTranscribing,
    },
});

const RESET_CREATOR_FORM_AFTER_SUBMIT = 'RESET_CREATOR_FORM_AFTER_SUBMIT';
export const resetCreatorFormAfterSubmit = (): CoreEntityPageAction => {
    const activityTypeId: string | null | undefined =
        INITIAL_CORE_ENTITY_PAGE_STATE.creatorForm.activityTypeId;

    return {
        type: RESET_CREATOR_FORM_AFTER_SUBMIT,
        payload: {
            activityTypeId,
            durationMinutes: INITIAL_CORE_ENTITY_PAGE_STATE.creatorForm.durationMinutes,
            pinNote: INITIAL_CORE_ENTITY_PAGE_STATE.creatorForm.pinNote,
        },
    };
};

const SET_ACTION_BAR_TAB = 'SET_ACTION_BAR_TAB';
export const setActionBarTab = (tab: TabOption): CoreEntityPageAction => ({
    type: SET_ACTION_BAR_TAB,
    payload: {
        tab,
    },
});

export const coreEntityPageReducer = (
    state: CoreEntityPageState | null | undefined = INITIAL_CORE_ENTITY_PAGE_STATE,
    action: CoreEntityPageAction
) => {
    switch (action.type) {
        case SET_CREATOR_FORM_ACTIVE:
        case SET_CREATOR_FORM:
        case SET_ACTIVITY_TYPE_ID:
        case SET_DURATION_MINUTES:
        case SET_PIN_NOTE:
        case SET_IS_TRANSCRIBING:
        case RESET_CREATOR_FORM_AFTER_SUBMIT:
            return {
                ...state,
                creatorForm: {
                    ...state?.creatorForm,
                    ...action.payload,
                },
            };
        case SET_ACTION_BAR_TAB:
            return {
                ...state,
                // @ts-expect-error
                actionBarTab: action.payload.tab,
            };
        default:
            unexpectedCase(null);

            return state;
    }
};
